import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgSupport2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 0 16 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 4l.084.001h.013L12 4a8 8 0 11-8 8v-.082a7.92 7.92 0 011.68-4.844l.205-.253a7.972 7.972 0 011.189-1.142l.236-.177A7.918 7.918 0 0111.918 4H12zm2.868 12.096l1.429 1.43a7.02 7.02 0 001.23-1.23l-1.43-1.428a5.052 5.052 0 01-1.23 1.228zm-7.004-1.285l-1.431 1.433c.353.462.762.88 1.217 1.24l1.427-1.427a5.04 5.04 0 01-1.213-1.246zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-5.527-.297l1.43 1.43a5.06 5.06 0 011.23-1.23l-1.43-1.43a7.088 7.088 0 00-1.23 1.23zm9.77-1.27l-1.432 1.431c.482.329.905.74 1.246 1.213l1.428-1.427a7.077 7.077 0 00-1.241-1.217z"
      />
    </svg>
  );
}

export default tombacIcon('Support2')(SvgSupport2);
